import { createFileRoute } from '@tanstack/react-router'
import { ProjectDetailsPage } from '../../pages/project-details/index.tsx'

export const Route = createFileRoute('/projects/$projectId')({
    component: ProjectDetailsPage,
})
